import {Component, Inject, OnDestroy} from '@angular/core';
import {L10N_LOCALE, L10nLocale} from 'angular-l10n';

@Component({
  selector: 'storever-loading-data',
  templateUrl: './loading-data.component.html',
  styleUrls: ['./loading-data.component.scss']
})
export class LoadingDataComponent  implements OnDestroy {

  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale) {  }

  ngOnDestroy(): void {
  }

}
